import { render } from "./ModalProductStopWorking.vue?vue&type=template&id=38d57b7e&scoped=true"
import script from "./ModalProductStopWorking.vue?vue&type=script&lang=js"
export * from "./ModalProductStopWorking.vue?vue&type=script&lang=js"

import "./ModalProductStopWorking.vue?vue&type=style&index=0&id=38d57b7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d57b7e"]])

export default __exports__